import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRestaurant } from 'redux/restaurant/use-restaurant';
import { useCompany } from 'redux/company/use-company';
import { useOwner } from 'redux/owner/use-owner';
import { useCommon } from 'redux/common/use-common';

// import { useDishes } from 'redux/dishes/use-dishes';
// import { useDishCategory } from 'redux/dishes_categories/use-dish-category';

export const useBootstrapCalls = () => {
  const location = useLocation();
  const { currentRestaurant } = useCommon();
  const {
    handleFetchInitialRestaurants: fetchRestaurantList,
    fetchSelectedRestaurant,
  } = useRestaurant();
  // const { handleGetDishes } = useDishes();
  // const { handleGetDishCategories } = useDishCategory();
  const { handleFetchInitialList: fetchCompanyList } = useCompany();
  const { handleFetchInitialList: fetchOwnerList } = useOwner();

  useEffect(() => {
    fetchSelectedRestaurant();
    if (location.pathname.includes('/profile')) {
      fetchOwnerList();
      fetchRestaurantList();
    }

    if (
      !location.pathname.includes('sign-in') ||
      !location.pathname.includes('forget-password')
    ) {
      fetchRestaurantList();
      fetchCompanyList();
    }

    if (location.pathname.includes('/menu')) {
      fetchRestaurantList();
    }

    return () => {
      if (location.pathname.includes('/profile')) {
        // resetListData();
      }
    };
  }, [location]);

  useEffect(() => {
    if (location.pathname.includes('/menu')) {
      if (currentRestaurant?.id) {
        // handleGetDishes();
        // handleGetDishCategories();
      }
    }
  }, [location, currentRestaurant]);

  return {};
};
